// Some producers return JSON-schema descriptions wrapped in a structured XML format
// like:
//   <root>
//     <div><label>description</label>:<b>Actual description text</b></div>
//     <div><label>businessTerm</label>:<b>...</b></div>
//   </root>
// The form fields render `schema.description` directly as the placeholder, so this
// markup leaks into the UI. This helper detects the wrapped format and extracts the
// description label's value; for any other HTML-tainted string it falls back to a
// plain tag strip. Plain text is returned unchanged.

const DESCRIPTION_LABEL_RE = /<label>\s*description\s*<\/label>\s*:\s*<b>([\s\S]*?)<\/b>/i
const HTML_TAG_RE = /<\/?[a-z][^>]*>/gi
const WHITESPACE_RUN_RE = /\s+/g

function cleanDescription(value) {
	if (typeof value !== 'string' || value.length === 0) return value
	if (!value.includes('<')) return value

	const labelMatch = value.match(DESCRIPTION_LABEL_RE)
	if (labelMatch && labelMatch[1]) return labelMatch[1].trim()

	return value.replace(HTML_TAG_RE, '').replace(WHITESPACE_RUN_RE, ' ').trim()
}

export { cleanDescription }
